<template>
  <button
    class="btn button-clear-filters"
    :class="{'mobile-view': mobile && !modal, ' mobile-view modal-clear-filters':mobile && modal}"
    @click="$emit('click')"
  >
    <i class="icon-close" :class="mobile ? 'xs' : 'sm'"></i>
    <span v-if="!mobile">{{ translate('offDealsClearAllFilters') }}</span>
    <span v-else>{{ translate('offDealsClearFilters') }}</span >
  </button>
</template>

<script>
export default {
  name: 'ClearAllFiltersBtn',
  props: {
    mobile: {
      type: Boolean,
      required: false,
      default: false
    },
    modal: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.button-clear-filters {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: color('primary');
  padding: 0;
  margin-left: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 2.5rem;

  span {
    line-height: 0;
  }

  &.mobile-view {
    margin-left: auto;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
    width: fit-content;

    &.modal-clear-filters {
      margin-left: 0;
      font-size: 12px;
    }
  }
}
</style>
